import { useState, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

import {
  headerForHazard,
  headerForKPI,
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
} from "./AgroAnalyticsUtils";
import i18n from "i18next";

import { mapHazardCodeToHazardProperty, getSimplifiedFromAnia, getSubintervals } from "../map/BivariateLogic";

import { fixedFormatter } from "../util/tableUtils";

/*
<==plain[1]  {
  Anno: '2024',
  CodiceGaranzia: '36',
  RischioClimatico: 'wind',
  
  DescrizioneGaranzia: 'FRE Venti Forti',
  Compagnia: '023',
  LR: 0,
  PremioNetto: 206,
  RisarcimentoTotale: 0,
 
  Specie_Group: '04 - UVA',
  Sx_Valass: 0,
  TIV_medio: 41200,
  ValoreAssicurato: 41200,
  _id: '2',
  costo_medio: 0,
  grado_medio_danno: 0,
  id: '2',
  incidenza: 0,
  n_pol: 1,
  n_sx: 0,
  premio_medio: 206,
  premio_puro_obs: 0,
  tasso_obs: 0,
  tasso_pagato: 5
}
*/

const aggregatedBivariateTableColumnsFunc = (hazardSelect, KPISelect) => [
  {
    field: "commune",
    headerName: i18n.t("cityCode"),
    width: 150,
  },

  {
    field: "communeName",
    headerName: i18n.t("city"),
    width: 300,
  },

  {
    field: "hazardValue",
    headerName: headerForHazard(hazardSelect) + " value",
    width: 300,
  },
  {
    field: "hazardLevel",
    headerName: " level",
    width: 100,
  },
  {
    field: "kpiValue",
    headerName: headerForKPI(KPISelect),
    width: 300,

    ...fixedFormatter,
  },
  {
    field: "kpiLevel",
    headerName: headerForKPI(KPISelect) + " level",
    width: 200,
  },
];

export const AgroBivariateGrid = ({
  filterModel,
  hazardSelect,
  KPISelect,
  wantedReferenceDateProp,
  setSelectedComuneIstatSetter,
}) => {
  const { t } = useTranslation();

  const [aggregatedBivariateTableState, setAggregatedBivariateTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedBivariateCancelTokenRef = useRef(null);

  const [aggregatedBivariateTableData, setAggregatedBivariateTableData] = useState([]);

  const onRowClickCallback = (params) => {
    const row = params.row;
    setSelectedComuneIstatSetter(row.commune); // row.id would work same way. It is "999999" comune Istat code.
  };

  useEffect(() => {
    const getAggregatedBivariateData = async () => {
      const cysHazardSelect = mapHazardCodeToHazardProperty[hazardSelect];

      const subIntervals = getSubintervals(KPISelect, hazardSelect, "AgroClimateAnalytics");
      return await getAggregatedData(
        setAggregatedBivariateTableState,
        setAggregatedBivariateTableData,
        // `aggrByMap~${hazardSelect}~${cysHazardSelect}~${KPISelect}~${lowValue}~${highValue}~${subIntervals}`,
        {
          aggr: "Map",
          hazardSelect: getSimplifiedFromAnia(hazardSelect),
          cysHazardName: cysHazardSelect,
          KPISelect,
          subIntervals,
        },
        filterModel,
        wantedReferenceDateProp,
        aggregatedBivariateCancelTokenRef,
      );
    };
    const getAggregatedBivariateDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedBivariateCancelTokenRef, getAggregatedBivariateData);
    };

    onFilterModelChange(filterModel, getAggregatedBivariateDataWrapper);
  }, [filterModel, hazardSelect, KPISelect, wantedReferenceDateProp]);

  const aggregatedBivariateTableColumns = aggregatedBivariateTableColumnsFunc(hazardSelect, KPISelect);
  return renderGrid(
    aggregatedBivariateTableColumns,
    aggregatedBivariateTableData,
    aggregatedBivariateTableState,
    t,
    "Bivariata",
    {
      onRowClick: onRowClickCallback,
    },
  );
};
